export const environment = {
  production: false,
  origin: 'https://tamwely-be-dev.up.railway.app/',
};
